import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { dashboardPathForUser } from "@/lib/roleRoutes";

const LINKS = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Career Universe", href: "#career-universe" },
  { label: "The Science", href: "/science" },
  { label: "For Schools", href: "#partner" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const goToApp = () => navigate(dashboardPathForUser(user));

  const handleNavClick = (e, href) => {
    if (!href.startsWith("#")) return;
    e.preventDefault();
    const id = href.slice(1);
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/${href}`);
    }
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/95 border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 h-18 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2 shrink-0">
          <BrandLogo className="h-8" />
        </div>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => handleNavClick(e, l.href)} className="text-sm text-slate-600 hover:text-indigo-600 transition-colors cursor-pointer">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Button data-testid="navbar-go-to-dashboard-button" onClick={goToApp} className="rounded-full bg-indigo-600 hover:bg-indigo-500 px-5">
              Go to Dashboard
            </Button>
          ) : (
            <>
              <Button variant="ghost" data-testid="navbar-login-button" onClick={() => navigate("/login")} className="text-slate-600 hover:text-indigo-600 hover:bg-slate-100">
                Log In
              </Button>
              <Button data-testid="navbar-start-journey-button" onClick={() => navigate("/login")} className="rounded-full bg-indigo-600 hover:bg-indigo-500 px-5">
                Start Your Career Assessment
              </Button>
            </>
          )}
        </div>
        <button className="md:hidden text-slate-600" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>
          <Menu className="h-6 w-6" />
        </button>
      </div>
      {open && (
        <div className="md:hidden px-6 pb-4 flex flex-col gap-3 bg-white border-t border-slate-100">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-slate-600"
              onClick={(e) => {
                handleNavClick(e, l.href);
                setOpen(false);
              }}
            >
              {l.label}
            </a>
          ))}
          {user ? (
            <Button data-testid="navbar-mobile-dashboard-button" onClick={() => { setOpen(false); goToApp(); }} className="rounded-full bg-indigo-600 hover:bg-indigo-500">
              Go to Dashboard
            </Button>
          ) : (
            <Button data-testid="navbar-mobile-start-button" onClick={() => { setOpen(false); navigate("/login"); }} className="rounded-full bg-indigo-600 hover:bg-indigo-500">
              Start Your Career Assessment
            </Button>
          )}
        </div>
      )}
    </header>
  );
}
